export enum FormValidations {
  FormValidation = 'FpEw',
  ValidationError = 'FCdi',
}
